import React, { useEffect, useState } from 'react';
import { apiService } from '../services/api';

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 20px 40px',
    background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a3a 100%)',
  },
  card: {
    maxWidth: '420px',
    width: '100%',
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '16px',
    padding: '2.5rem',
    color: '#e5e7eb',
    textAlign: 'center',
  },
  heading: {
    color: '#fff',
    marginBottom: '1.5rem',
  },
  count: {
    fontSize: '3rem',
    fontWeight: 700,
    color: '#8b5cf6',
    margin: '0 0 0.5rem',
  },
  label: {
    color: '#9ca3af',
    fontSize: '0.9rem',
  },
  error: {
    color: '#ef4444',
  },
};

const PromptBuilderAdminPage = () => {
  const [count, setCount] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiService
      .getPromptBuilderUsage()
      .then(setCount)
      .catch(() => setError('Could not fetch usage.'));
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.heading}>AI Prompt Builder — Usage</h1>
        {error ? (
          <p style={styles.error}>{error}</p>
        ) : (
          <>
            <p style={styles.count}>{count === null ? '…' : count}</p>
            <p style={styles.label}>prompts generated total</p>
          </>
        )}
      </div>
    </div>
  );
};

export default PromptBuilderAdminPage;
